import { createSlice } from "@reduxjs/toolkit";
import {
  getDocuments,
  addNewDocument,
  updateDocument,
  deleteDocument,
  getArchives,
  addNewArchive,
  updateArchive,
  deleteArchive,
} from "./thunk";

export const initialState = {
  documents: [],
  error: {},
  isLoading: false,
  isDocumentsSuccess: false,
  isDocumentsFailed: false,

  archives: [],
  archivesError: {},
  isArchivesLoading: false,
  isArchivesSuccess: false,
  isArchivesFailed: false,
  isArchiveUpdate: false,
};

const documentsSlice = createSlice({
  name: "document",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //==================================[ /getDocuments/ ]=======================================
    builder.addCase(getDocuments.pending, (state) => {
      state.isLoading = true;
      state.isDocumentsSuccess = false;
      state.error = null;
    });
    builder.addCase(getDocuments.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isDocumentsSuccess = true;
      state.documents = action.payload;
    });
    builder.addCase(getDocuments.rejected, (state, action) => {
      state.isLoading = false;
      state.isDocumentsSuccess = false;
      state.error = action.error.message;
    });

    builder.addCase(addNewDocument.fulfilled, (state, action) => {
      state.documents.push(action.payload);
      state.isDocumentAdd = true;
      state.isDocumentAddFail = false;
    });

    builder.addCase(addNewDocument.rejected, (state, action) => {
      state.error = action.payload.error || null;
      state.isDocumentAdd = false;
      state.isDocumentAddFail = true;
    });

    builder.addCase(updateDocument.fulfilled, (state, action) => {
      state.documents = state.documents.map((doc) =>
        doc._id.toString() === action.payload._id.toString()
          ? { ...doc, ...action.payload }
          : doc
      );
      state.isDocumentUpdate = true;
      state.isDocumentUpdateFail = false;
    });

    builder.addCase(updateDocument.rejected, (state, action) => {
      state.error = action.payload.error || null;
      state.isDocumentUpdate = false;
      state.isDocumentUpdateFail = true;
    });

    builder.addCase(deleteDocument.fulfilled, (state, action) => {
      state.documents = (state.documents || []).filter(
        (doc) => doc._id.toString() !== action.payload.id.toString()
      );

      state.isDocumentDelete = true;
      state.isDocumentDeleteFail = false;
    });

    builder.addCase(deleteDocument.rejected, (state, action) => {
      state.error = action.payload.error || null;
      state.isDocumentDelete = false;
      state.isDocumentDeleteFail = true;
    });

    //==================================[ /getArchives/ ]=======================================
    builder.addCase(getArchives.pending, (state) => {
      state.isArchivesLoading = true;
      state.isArchivesSuccess = false;
      state.archivesError = null;
    });
    builder.addCase(getArchives.fulfilled, (state, action) => {
      state.isArchivesLoading = false;
      state.isArchivesSuccess = true;
      state.archives = action.payload;
    });
    builder.addCase(getArchives.rejected, (state, action) => {
      state.isArchivesLoading = false;
      state.isArchivesSuccess = false;
      state.archivesError = action.error.message;
    });

    builder.addCase(addNewArchive.fulfilled, (state, action) => {
      state.archives.push(action.payload);
      state.isArchiveAdd = true;
      state.isArchiveAddFail = false;
    });

    builder.addCase(addNewArchive.rejected, (state, action) => {
      state.archivesError = action.payload.error || null;
      state.isArchiveAdd = false;
      state.isArchiveAddFail = true;
    });

    builder.addCase(updateArchive.fulfilled, (state, action) => {
      state.archives = state.archives.map((doc) =>
        doc._id.toString() === action.payload._id.toString()
          ? { ...doc, ...action.payload }
          : doc
      );
      state.isArchiveUpdate = true;
      state.isArchiveUpdateFail = false;
    });

    builder.addCase(updateArchive.rejected, (state, action) => {
      state.archivesError = action.payload.error || null;
      state.isArchiveUpdate = false;
      state.isArchiveUpdateFail = true;
    });

    builder.addCase(deleteArchive.fulfilled, (state, action) => {
      state.archives = (state.archives || []).filter(
        (doc) => doc._id.toString() !== action.payload.id.toString()
      );

      state.isArchiveDelete = true;
      state.isArchiveDeleteFail = false;
    });

    builder.addCase(deleteArchive.rejected, (state, action) => {
      state.archivesError = action.payload.error || null;
      state.isArchiveDelete = false;
      state.isArchiveDeleteFail = true;
    });
  },
});

export default documentsSlice.reducer;
